import type { ApolloClient } from "@apollo/client";
import {
  getMediaDownloadUrl,
  WallProviderRemote,
} from "@package/ui-wall-engine";

// Every WallProvider method Trivia calls besides fetchMediaUrl is already optional-chained
// (provider?.onFlyoutClosed(...) etc.), so WallProviderRemote's no-ops are safe as-is. Only
// media resolution needs to be real for a CMS-embedded preview to show question/answer images.
export class WallProviderPreview extends WallProviderRemote {
  constructor(private readonly client: ApolloClient<object>) {
    super();
  }

  public override async fetchMediaUrl(media?: string): Promise<string | void> {
    if (!media) {
      return;
    }

    return (await getMediaDownloadUrl(this.client, media))?.url;
  }
}
